const eventMap = {
    ON_CITY_SELECTION: "ON_CITY_SELECTION"
};

export const emitEventNames = {
    desktop: { ...eventMap },
    mobile: { ...eventMap }
};
